import React from "react";
import Header from "app/components/checkout/steps/partials/Header";
import CloseButton from "app/components/checkout/steps/partials/CloseButton";
import NextButton from "app/components/checkout/steps/partials/NextButton";
import PrevButton from "app/components/checkout/steps/partials/PrevButton";
import PropTypes from "prop-types";
import AlcoholWarning from "../AlcoholWarning";
const Trans = require('app/components/trans/Trans')

export default class Step extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            error: null,
            active: props.active,
            blur: props.blur,
            transitioning: false,
            submitting: false,
            cart: props.cart,
            ...this.defaultState
        };

    }

    get defaultState() {
        return {};
    }

    /////////////////////////////////
    // Configuration
    /////////////////////////////////

    static get propTypes() {
        return {
            active: PropTypes.bool.isRequired,
            blur: PropTypes.bool.isRequired,
            next: PropTypes.func.isRequired,
            prev: PropTypes.func.isRequired,
            prevAction: PropTypes.string,
            nextAction: PropTypes.string,
            hasPrevAction: PropTypes.bool,
            hasNextAction: PropTypes.bool,
            index: PropTypes.number.isRequired,
            count: PropTypes.number.isRequired,
            cart: PropTypes.object.isRequired,
            pipelines: PropTypes.object.isRequired,
            showIndex: PropTypes.bool,
            hasPrevStep: PropTypes.bool,
            hasNextStep: PropTypes.bool,
            transitionDuration: PropTypes.number
        };
    }

    static get defaultProps() {
        return {
          prevAction: translate('Tilbage'),
            nextAction: translate('Næste'),
            hasNextAction: true,
            hasPrevAction: true,
            showIndex: true,
            hasPrevStep: true,
            hasNextStep: true,
            transitionDuration: 300
        };
    }

    /////////////////////////////////
    // React methods
    /////////////////////////////////

    componentWillReceiveProps(nextProps) {

        if ((nextProps.active && !this.state.active) || (!nextProps.active && !nextProps.blur)) {
            this.onFocus();
        }


        let payload = {};

        ['active', 'blur', 'cart'].forEach(propName => {
            if (nextProps[propName] !== this.state[propName]) {
                payload[propName] = nextProps[propName];
            }
        });

        if (Object.keys(payload).length > 0) {

            // Add transitioning
            if (payload.active !== this.state.active) {
                payload.transitioning = true;
            }

            this.setState(payload);

            if (payload.transitioning) {
                setTimeout(() => this.setState({transitioning: false}), this.props.transitionDuration);
            }

        }

    }

    /////////////////////////////////
    // Assorted helpers
    /////////////////////////////////

    onFocus() {
        ///
    }

    get baseClassName() {
        return "";
    }

    get className() {
        let classList = ["step", this.baseClassName];

        if (this.state.blur) {
            classList.push("blur");
        }

        if (this.state.active) {
            classList.push("active");
        }

        if (this.state.submitting) {
            classList.push("submitting");
        }

        if (this.state.transitioning) {
            classList.push("transitioning");
        }

        return classList.join(" ");
    }

    get cart() {
        return this.state.cart;
    }

    get pipelines() {
        return this.props.pipelines;
    }

    /////////////////////////////////
    // Prev/Next helpers
    /////////////////////////////////

    get nextActionLabel() {
        return this.props.nextAction;
    }

    get prevActionLabel() {
        return this.props.prevAction;
    }

    handlePrevNext(type = 'next') {
        return new Promise((resolve, reject) => {

            if (this.state.submitting) {
                return resolve();
            }

            this.setState({submitting: true}, () => {

                let handler = (type === 'next') ? this.onNext() : this.onPrev();

                handler
                    .then(() => {
                        this.setState({submitting: false}, () => {
                            (type === 'next') ? this.props.next() : this.props.prev();
                            resolve();
                        });
                    })
                    .catch((err) => {
                        this.setState({submitting: false}, () => {
                            if (err) {
                                console.error('Got error trying to submit step', err);
                            }
                            resolve();
                        });
                    });

            });

        });
    }

    prev() {
        return this.handlePrevNext('prev');
    }

    onPrev() {
        return Promise.resolve();
    }

    next() {
        return this.handlePrevNext('next');
    }

    onNext() {
        return Promise.resolve();
    }

    /////////////////////////////////
    // Event helpers
    /////////////////////////////////

    resetErrors = () => {
        this.setState({error: null});
    };

    /////////////////////////////////
    // Rendering helpers
    /////////////////////////////////

    get nextButtonProps() {
        return {};
    }

    get prevButtonProps() {
        return {};
    }

    renderNextButton() {

        const {hasNextAction, hasNextStep} = this.props;

        if (!hasNextAction) {
            return;
        }

        return (
            <NextButton onResolve={this.next.bind(this)} displayArrow={hasNextStep} label={this.nextActionLabel} {...this.nextButtonProps}/>
        );
    }

    renderPrevButton() {

        const {hasPrevAction, hasPrevStep} = this.props;

        if (!hasPrevAction) {
            return;
        }

        return (
            <PrevButton onResolve={this.prev.bind(this)} displayArrow={hasPrevStep} label={this.prevActionLabel} {...this.nextButtonProps}/>
        );
    }

    renderAdditionalActions() {

    }

    renderError() {
        if (!this.state.error) {
            return;
        }

        return (
            <div className="error status-error">{this.state.error}</div>
        );
    }

    renderBody() {
        return (
            <div className="step-body">
                <Header showIndex={this.props.showIndex}
                        step={this.props.index}
                        stepsCount={this.props.count}
                        title={this.title}
                        description={this.description}>
                    {this.renderAdditionalActions()}
                </Header>
                <div className="step-contents">{this.renderStep()}</div>
                <div className="step-footer">
                    <CloseButton/>
                    {this.renderPrevButton()}
                    {this.renderNextButton()}
                </div>
                <AlcoholWarning/>
            </div>
        );
    }

    render() {
        return (
            <div ref={el => this.stepElement = el} className={this.className}>{this.renderBody()}</div>
        );
    }

}
